module.exports = __webpack_public_path__ + "img/ring_y_l_null_0@2x.e45ab020.png";